import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const cashFlowRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/cash-flow',
  component: lazyRouteComponent(() => import('@/pages/cash-flow/cash-flow-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
      main_balance_id: search.main_balance_id as string | undefined,
      start_date: search.start_date as string,
      end_date: search.end_date as string,
    };
  },
});
